/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/prefer-regexp-exec */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/**
 * 原生方法 https://gitlab.hellobike.cn/Carfee/HBridge/blob/master/api.md
 */
import store from '@/store';
import { Toast } from '@hb/coffee';
import platform from '@/shared/utils/platform';
import { FaceCheckEnum, HitchTakePhotoTypeEnum, LocationAlertStateEnum } from '@/enums/native';
import { callNative } from '@/shared/utils/bridge';
import { versionCompare } from '@/shared/utils/versionCompare';
import { NativeVo } from '@/vo/Native';

import {
  ContractInfo,
  DirectItemShareInfo,
  SignApply,
} from './types';

const PleaseUpgrade = '请升级app到最新版本以使用该功能';

// 判断客户端版本是否低于目标版本
const isVersionLargerOrEqual = (version: string): boolean => {
  if (versionCompare(store.state.base.deviceInfo.appVersion || '5.82.0', version) < 0) {
    Toast('请升级app到最新版本以使用该功能');
    return false;
  }

  return true;
};

// 给没有定位权限手机展示提醒的弹窗，点确定会跳转到系统设置页,提示内容可以通过配置content展示
const _showLocationAlertOld = (content: string) => callNative({
  classMap: 'SystemUtil',
  method: 'showLocationAlert',
  params: {
    content,
  },
});

// 给没有定位权限手机展示引导提醒的弹窗，点确定会跳转到系统设置页,提示内容可以通过配置content展示
// 返回 {state: LocationAlertStateEnum}
export const showLocationGuideAlert = (content: string): Promise<{ state: LocationAlertStateEnum }> => callNative({
  classMap: 'SystemUtil',
  method: 'showLocationGuideAlert',
  params: {
    content,
  },
});

// 给没有定位权限手机展示提醒的弹窗，点确定会跳转到系统设置页,提示内容可以通过配置content展示
// 客户端版本号大于等于6.98.20的时候用新方法，小于的用老方法
// 统一返回 Promise<{ state: LocationAlertStateEnum }>，旧版本默认返回 CONFIRMED
export const showLocationAlert = (content: string): Promise<{ state: LocationAlertStateEnum }> => {
  const appVersion = store.state.base.deviceInfo.appVersion || '5.82.0';
  if (versionCompare(appVersion, '6.98.20') >= 0) {
    return showLocationGuideAlert(content);
  }
  // 旧版本没有返回值，默认返回确认状态，保持向后兼容
  return _showLocationAlertOld(content).then(() => ({
    state: LocationAlertStateEnum.CONFIRMED,
  }));
};

/** 无调用场景 */
export const jumpToHome = () => callNative({ classMap: 'SystemUtil', method: 'jumpToHome', params: {} });

// 将base64图片保存到相册 -- 无调用
export const savePicture = (base64Data: string) => callNative({
  classMap: 'Third',
  method: 'savePicture',
  params: {
    base64Data,
  },
});

// 面部识别
// 无调用
export const checkFaceLiveness = (
  extraParams: NativeVo.LivenessParam,
): Promise<{ status: FaceCheckEnum; orderId: string }> => callNative({
  classMap: 'business/finance',
  method: 'financeFaceLiveness',
  params: {
    extraParams,
    token: store.state.base.originUserInfo.token,
  },
});

// 当前客户端版本是否支持身份证拍照的cropRatio属性
export const isCropRatioSupportedInHitchTakePhotos = (): boolean => {
  const versionMatch = /version=([\d.]*)/.exec(navigator.userAgent);
  const appVersion = (versionMatch && versionMatch[1]) || '';

  if (platform.isHelloApp) {
    return !!(
      ((platform.isAndroid || platform.isHarmony) && versionCompare(appVersion, '5.65.0') >= 0)
      || (platform.isIOS && versionCompare(appVersion, '5.73.0') >= 0)
    );
  }

  return false;
};

export const takeIdentityPhoto = (
  type: HitchTakePhotoTypeEnum,
  cropRatio?: number | undefined,
): Promise<{ photoPath: string; photoStr: string }> => {
  let classMap = 'Business';
  let method = 'hitchTakePhotos';

  if (platform.isSkApp) {
    classMap = 'SKAppUtils';
    method = 'skTakePhotos';
  }

  return callNative({
    classMap,
    method,
    params: {
      // 1. 身份证头像面 2.身份证国徽面 3.驾驶证 4.行驶证 5. 车辆照
      type,
      // 支持根据指定的比例按照屏幕尺寸计算最终照片的像素大小，默认按照边框进行裁切
      ...(isCropRatioSupportedInHitchTakePhotos() && cropRatio
        ? {
          cropRatio,
        }
        : {}),
    },
  });
};

// 拍摄身份证
export const takeFrontPhoto = (cropRatio?: number | undefined) => takeIdentityPhoto(
  HitchTakePhotoTypeEnum.TYPE_IDENTIFICATION_FRONT,
  cropRatio,
);

// 相册选择
export const selectPhotos = (
  maxSelectNum = 1, // 最大选择数量
  mimeType = 1, // 文件类型 1:image 2:video 3:audio （iOS不支持音频）
): Promise<{ width: number; height: number; path: string; }[]> => callNative({
  classMap: 'ui',
  method: 'platformPick',
  params: {
    maxSelectNum,
    mimeType,
  },
});

/**
 * 根据path获取base64值
 * width属性，Android使用1x，IOS使用2x，如传入800，Android宽度为800，IOS宽度为1600
 * */
export const getBase64ByPath = (
  path: string,
  config : {
    mimeType?: number;
    height?: number;
    width?: number;
    crop?: number;
    quality?: number;
  },
): Promise<{ imageBase64: string; }> => callNative({
  classMap: 'ui',
  method: 'platformGetThumbnail',
  params: {
    ...config,
    path,
  },
});

export const takeBackPhoto = (
  cropRatio?: number | undefined,
) => takeIdentityPhoto(HitchTakePhotoTypeEnum.TYPE_IDENTIFICATION_BACK, cropRatio);

// 获取通讯录中联系人信息
// 无调用场景
export const getContracts = (): Promise<{
  status: 0 | 1;
  data: ContractInfo[];
}> => callNative({
  classMap: 'business/finance',
  method: 'financeContactInfo',
});

/** 无调用 */
// 获取跳到支付宝时需要传入的返回schema
export const getAliReturnUrl = (): Promise<string> => {
  if (!isVersionLargerOrEqual('5.23.0')) {
    return Promise.reject(new Error(PleaseUpgrade));
  }

  return callNative<{
    returnUrl: string;
  }>({
    classMap: 'ThirdPay',
    method: 'getAliReturnUrl',
  }).then((data) => data.returnUrl);
};

// 支付宝支付或签约，签约会跳到支付宝app，支付唤起sdk的收银台 API_TODO
/** 无调用 */
export const aliPayOrSign = ({
  type,
  serialNumber,
  thirdCode,
}: {
  type: 'PAY' | 'SIGN';
  serialNumber: string;
  thirdCode: string;
}): Promise<{ state: -1 | 0; msg: string }> => {
  if (!isVersionLargerOrEqual('5.23.0')) {
    return Promise.reject(new Error(PleaseUpgrade));
  }

  return callNative({
    classMap: 'ThirdPay',
    method: 'aliPayOrSign',
    params: {
      type,
      serialNumber,
      thirdCode, // 001表示趣店，其余请扩展
    },
  });
};

/**
 * 点击分享
 * @param option.miniProgramId 小程序的id => 小程序分享独有
 * @param option.miniProgramPath 小程序路径 => 小程序分享独有
 * @param option.miniProgramType 小程序环境 => 小程序分享独有
 * @param option.shareUrl 分享地址 => 必填,当小程序参数传递后会以小程序参数为主
 * @param option.title 分享标题
 * @param option.desc 分享内容文字
 * @param option.shareImageUrl 分享图片地址
 * @param option.shareImageBase64 分享图片base64(需要mediaType为2,生效时shareImageUrl失效)
 * @param option.tapType 类型见如下：
 * {
 *    weChatFriends: 1,
 *    friendCircle: 2,
 *    qq: 3,
 *    qqZone: 4,
 *    weiBo: 5,
 *    QRCode: 6,
 *    message: 7,
 * }
 */
export const directItemShare = (option: DirectItemShareInfo) => callNative({
  classMap: 'Share',
  method: 'directItemShare',
  params: option,
});

// 新银河-签约
export const signWithAliPay = (options: SignApply) => {
  if (!isVersionLargerOrEqual('5.75.0')) {
    return Promise.reject(new Error(PleaseUpgrade));
  }
  return callNative({
    classMap: 'NewAllPay',
    method: 'signWithAliPay',
    params: options,
  });
};

// 新银河-支付
export const payWithAliPay = (options: SignApply) => {
  if (!isVersionLargerOrEqual('5.75.0')) {
    return Promise.reject(new Error(PleaseUpgrade));
  }
  return callNative({
    classMap: 'NewAllPay',
    method: 'payWithAliPay',
    params: options,
  });
};

// 禁止webview iOS侧滑功能
export const webViewInteractivePopDisabled = (disable: boolean): Promise<void> => callNative({
  classMap: 'NavBar',
  method: 'webViewInteractivePopDisabled',
  params: {
    disable,
  },
});

// 禁止native iOS侧滑功能
export const nativeInteractivePopDisabled = (disable: boolean): Promise<void> => callNative({
  classMap: 'NavBar',
  method: 'nativeInteractivePopDisabled',
  params: {
    disable,
  },
});

// 获取平台用户信息
export const callLocalGetTokenAndKey = (needLogin:boolean, extendValue:Dictionary): Promise<NativeModel.OriginUserInfo> => callNative({
  classMap: 'User',
  method: 'getTokenAndKey',
  params: {
    needLogin,
    extendValue: JSON.stringify(extendValue),
  },
});

/** 设置ios弹性下拉功能 */
export const setIosBouncesEable = (enable: boolean): void => {
  if (platform.isEasyBike && platform.isIOS && isVersionLargerOrEqual('5.75.0')) {
    callNative({
      classMap: 'Third',
      method: 'setBouncesEable',
      params: {
        bouncesEable: enable ? 1 : 0,
      },
    });
  }
};

const NativeApi = {
  showLocationAlert,
  jumpToHome,
  savePicture,
  checkFaceLiveness,
  isCropRatioSupportedInHitchTakePhotos,
  takeIdentityPhoto,
  takeFrontPhoto,
  takeBackPhoto,
  getContracts,
  getAliReturnUrl,
  aliPayOrSign,
  directItemShare,
  signWithAliPay,
  payWithAliPay,
  nativeInteractivePopDisabled,
  webViewInteractivePopDisabled,
  selectPhotos,
  getBase64ByPath,
  callLocalGetTokenAndKey,
};

export default NativeApi;
